module.exports = __webpack_public_path__ + "img/mark_content.07a9c44a.png";